import "./assets/main.scss";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import * as Sentry from "@sentry/vue";

const app = createApp(App);

const sentryDsn = "https://84c653e72f834a36d76e44dd75598af3@o4508382830329856.ingest.de.sentry.io/4508382832164944";

Sentry.init({
	app,
	tunnel: `${import.meta.env.VITE_API_ENDPOINT}/api/v1/sentry`,
	dsn: sentryDsn,
	integrations: [
		Sentry.replayIntegration(),
		Sentry.feedbackIntegration({
			colorScheme: "system",
		})
	],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(router);
app.mount("#app");
